<template>
  <!-- 投票广告 -->
  <div
    class="noborderAD"
    v-if="info.advdata.type == 2 && noborderPop"
    @touchmove.prevent
    @mousewheel.prevent
  >
    <div class="content" v-show="show">
      <p class="title">{{ noborderWord }}</p>
      <div class="imgPop">
        <img
          @click="gotoLink()"
          @load="loadImage()"
          class="imgBase"
          :src="info.advdata.advimg"
          alt=""
        />
      </div>
      <div class="close">
        <van-icon @click="close()" name="close" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      info: JSON.parse(sessionStorage.getItem("info")),
      show: false,
    };
  },
  methods: {
    ...mapMutations("showData", ["changeTFalse"]),
    close() {
      this.changeTFalse([{ name: "noborderPop", value: false }]);
    },
    gotoLink() {
      location.href = this.info.advdata.advurl;
    },
    loadImage() {
      this.show = true;
    },
  },
  computed: {
    ...mapState("showData", ["noborderPop"]),
    ...mapState("activeData", ["noborderWord"]),
  },
};
</script>

<style lang="less" scoped>
.noborderAD {
  width: 100%;
  max-width: 10rem;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000000;
  box-sizing: border-box;
  padding: 0 0.4rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  div.content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  p.title {
    font-size: 0.3733rem;
    color: #fff;
    margin-bottom: 0.5333rem;
    text-align: center;
    width: 100%;
  }
  div.imgPop {
    width: 100%;
    font-size: 0;
    text-align: center;
    img {
      // width: 100%;
      max-width: 100%;
    }
  }
  div.close {
    margin-top: 0.5333rem;
    width: 100%;
    text-align: center;
    .van-icon-close {
      font-size: 0.5333rem;
      color: #fff;
    }
  }
}
</style>